import { apiCall } from '../helpers/requestHelper';

// todo: This file is created as start of refactoring process

export default {
  getProducts() {
    return apiCall('/api/products/', 'get');
  }
};
